exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._login-card{width:100%;max-width:390px}._login-card .main-icon{background-image:url(" + require("../../../../assets/icons/logo.svg") + ");background-position:50%;background-repeat:no-repeat;background-size:contain;height:61px;width:100px}._login-card .tabs__items{border:0}._login-card .tabs__content{height:340px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/stylus-loader!./src/components/plain/loginCard/loginCard.styl
// module id = 426
// module chunks = 0